<template>
<div class="mReportList">
    <div class="title_box">
        <div class="title_text_box">
            <label></label>
            <span>免费报告</span>
        </div>
        <div @click="findIndexReportByFree()" class="refresh_box">
            <img :src="require('@/common/images/report/mobile/icon_refresh.png')" alt="">
            <span>换一批</span>
        </div>
    </div>
    <div class="report_list_warp">
        <div  @click="toReportDetails(item)" class="report_list_item" v-for="(item, index) in reportListData" :key="index">
            <div v-if="index < 2" class="report_big_box">
                <div class="img_box">
                    <img v-lazy="item.coverurl" :alt="item.subject">
                </div>
                <div class="van-multi-ellipsis--l2">{{item.subject}}</div>
            </div>
            <div v-else class="report_little_box">
                <div class="img_box">
                    <img v-lazy="item.coverurl" :alt="item.subject">
                </div>
                <div class="van-ellipsis">{{item.subject}}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getIndexReportByFree} from 'api/reportApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'mFreeReportList',
    data() {
        return {
            reportListData: []
        }
    },
    mounted() {
        setTimeout(()=>{
            this.findIndexReportByFree()
        }, 0)
    },
    methods: {
        // 点击报告
        toReportDetails(val) {
            // console.log(val)
            this.setRefresh(true)
            this.$router.push({name: 'MReportDetails', query: {'reportid': val.innerid}})
        },
        findIndexReportByFree() {
            this.setLoading(true)
            getIndexReportByFree({
                data: {},
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.reportListData = data.data.freereportlist
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.mReportList {}
</style>